export let CalendarGridTimeEventCssVars = /*#__PURE__*/function (CalendarGridTimeEventCssVars) {
  CalendarGridTimeEventCssVars["yPosition"] = "--y-position";
  CalendarGridTimeEventCssVars["height"] = "--height";
  return CalendarGridTimeEventCssVars;
}({});